const BASE_URL = import.meta.env.VITE_LL_ENDPOINT;

const CLIENT_ID = import.meta.env.VITE_LL_CLIENT_ID;

export const fetchProgramByCustomId = async ({
  customId,
}: {
  customId: string;
}) => {
  const url = `${BASE_URL}/program-by-custom-id/${CLIENT_ID}/${customId}/`;

  return await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      throw new Error(error);
    });
};
